
import { defineComponent } from 'vue'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue'
import Animate from '@/components/Common/Animate.vue'

import BackgroundImage from '@/components/Common/BackgroundImage.vue'
import Quote from '@/components/Common/Quote.vue'
import Button from '@/components/Common/Button.vue'

export default defineComponent({
    name: 'Services',
    components: {
        ScrollParallax,
        BackgroundImage,
        Quote,
        Button,
        Animate,
    },
    setup() {
        const serviceList = [
            {
                id: 'code',
                icon: require('../assets/icons/services-code-icon.svg'),
                heading: 'Utveckling av mjukvara för detaljhandeln',
                text:
                    'På uppdrag utvecklar vi både back-end och front-end baserat på dina behov inom ramen för vår mångåriga kunnande av detaljhandeln',
            },
            {
                id: 'apps',
                icon: require('../assets/icons/services-apps-icon.svg'),
                heading: 'Egenutvecklade system och applikationer',
                text:
                    'Med all vår erfarenhet från detaljhandeln har vi utvecklat programvaror för olika butikstillämpningar som går snabbt och enkelt att komma igång med',
            },
            {
                id: 'maintenance',
                icon: require('../assets/icons/services-maintenance-icon.svg'),
                heading: 'Applikationsförvaltning',
                text:
                    'Oavsett om det handlar om mjukvara utvecklat specifikt för er eller våra egna produkter kan vi hjälpa till med förvaltning efter applikationen gått live',
            },
            {
                id: 'project',
                icon: require('../assets/icons/services-project-icon.svg'),
                heading: 'Projektledning, testledning och dokumentation',
                text:
                    'Behöver ni hjälp att komma igång med eller få på plats ett nytt system eller en ny applikation. Vi kan hjälpa till med projektledningen, test och dokumentationen',
            },
            {
                id: 'solution',
                icon: require('../assets/icons/services-solution-icon.svg'),
                heading: 'Konsultationstjänster och lösningsbeskrinvningar',
                text:
                    'Med vår mångåriga erfarenhet från detaljhandeln kan vi hjälpa till med t.ex. förstudier eller liknande arbete för att detaljera lösningsförslag och beslutsunderlag',
            },
            {
                id: 'support',
                icon: require('../assets/icons/services-support-icon.svg'),
                heading: 'Third line support',
                text:
                    'Behöver ni experthjälp så kan vi ta uppdrag där vi agerar som så kallad “third line support”. Vi är den sista utposten och hjälper till när frågorna är extra svåra att lösa',
            },
        ]

        return {
            serviceList,
        }
    },
})
